export default {"src":"/_next/static/media/contactid.a7d9fd59.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};